import { render } from "./Physio.vue?vue&type=template&id=73b2820e&scoped=true"
import script from "./Physio.vue?vue&type=script&lang=js"
export * from "./Physio.vue?vue&type=script&lang=js"

import "./Physio.vue?vue&type=style&index=0&id=73b2820e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b2820e"]])

export default __exports__